import { useEffect } from "react";

const SITE = "Studio Fotografico Santarelli";
const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};
const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
  el.setAttribute("href", href);
};
const absUrl = (src) => (/^https?:/.test(src) ? src : `${window.location.origin}${src.startsWith("/") ? "" : "/"}${src}`);

export const useSeo = (title, description, raw = false, { image, noindex } = {}) => {
  useEffect(() => {
    const full = raw && title ? title : title ? `${title} · ${SITE} · L'Aquila` : `${SITE} · Fotografi dal 1982 · L'Aquila`;
    const url = `${window.location.origin}${window.location.pathname}`;
    document.title = full;
    if (description) { setMeta("name", "description", description); setMeta("property", "og:description", description); setMeta("name", "twitter:description", description); }
    setMeta("property", "og:title", full);
    setMeta("name", "twitter:title", full);
    setMeta("property", "og:url", url);
    setCanonical(url);
    if (image) { setMeta("property", "og:image", absUrl(image)); setMeta("name", "twitter:image", absUrl(image)); }
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
  }, [title, description, raw, image, noindex]);
};

export const useJsonLd = (data) => {
  const json = data ? JSON.stringify(data) : "";
  useEffect(() => {
    if (!json) return undefined;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.dataset.page = "1";
    el.text = json;
    document.head.appendChild(el);
    return () => el.remove();
  }, [json]);
};

export const pageJsonLd = (page, image) => {
  const origin = window.location.origin;
  const url = `${origin}${window.location.pathname}`;
  const provider = { "@type": "LocalBusiness", name: SITE, url: `${origin}/`, telephone: "+393285979670" };
  const graph = [{ "@type": "WebPage", "@id": url, url, name: page.seo_title || page.title, description: page.meta_description || "", inLanguage: "it-IT",
    isPartOf: { "@type": "WebSite", name: SITE, url: `${origin}/` }, ...(image ? { primaryImageOfPage: absUrl(image) } : {}) }];
  if (page.slug !== "home") graph.push({ "@type": "BreadcrumbList", itemListElement: [
    { "@type": "ListItem", position: 1, name: "Home", item: `${origin}/` },
    { "@type": "ListItem", position: 2, name: page.title || page.name, item: url }] });
  if (page.category && page.category !== "generale") graph.push({ "@type": "Service", name: `${page.title || page.name} a L'Aquila`, serviceType: page.title || page.name,
    description: page.meta_description || "", areaServed: "L'Aquila", provider, url, ...(image ? { image: absUrl(image) } : {}) });
  return { "@context": "https://schema.org", "@graph": graph };
};
